import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { useQuery } from 'react-query';
import FitnessJoinOurNetworkMobileHeader from '../../assets/FitnessJoinOurNetworkMobileHeader.png';
import FitnessJoinOurNetworkDesktopHeader from '../../assets/FitnessJoinOurNetworkDesktopHeader.png';
import useIsMobile from '../../hooks/useIsMobile';
import { GetFitnessJoinOurNetworkSectionsFn } from '../../data/apiCalls';
import CustomNoResultsOverlay from '../Errors/NoResultsOverlay';
import PagesBanner from '../shared/Pages/PageBanner';
import FitnessPageSkeletonLoading from './FitnessPageSkeletonLoading';
import FitnessPageSection from './FitnessPageSection';

const FitnessPage = () => {
	const pageTitle = 'Join Our Network - Fitness Centers';
	const isMobile = useIsMobile();
	const {
		data: {
			status = undefined,
			data: { resultCode = undefined, data: { results = [] } = {} } = {},
		} = {},
		isLoading,
		isError,
	} = useQuery(
		['fitnessJoinOurNetworkSections'],
		() => GetFitnessJoinOurNetworkSectionsFn(),
		{
			staleTime: Infinity,
		}
	);
	const showNoResultsOverlay = isError || (status >= 400 && status <= 505);

	return (
		<Container>
			<PagesBanner
				imageUrl={
					isMobile
						? FitnessJoinOurNetworkMobileHeader
						: FitnessJoinOurNetworkDesktopHeader
				}
				error={false}
				title='Take Your Facility to the Next Level'
			/>
			<Typography component='h1' variant='h4' mt={3}>
				{pageTitle}
			</Typography>
			<Divider sx={{ my: { xs: 2, md: 3 } }} />
			<Typography
				component='p'
				variant='body1'
				sx={{ mb: { xs: 2, md: 6 } }}
			>
				Thank you for your interest in becoming a Contracted Fitness
				Center, Fitness Studio and YMCA with American Specialty Health.
				To learn more about ASH and how to join our network, please
				review this webpage and see what ASH can offer to your facility.
			</Typography>
			{isLoading && <FitnessPageSkeletonLoading />}
			{showNoResultsOverlay && (
				<Container sx={{ pt: 3 }}>
					<CustomNoResultsOverlay
						resultCode={resultCode}
						statusCode={status}
					/>
				</Container>
			)}
			{!isLoading &&
				!showNoResultsOverlay &&
				results
					.sort((a, b) => (a.orderNumber < b.orderNumber ? -1 : 1))
					.map((result, index) => (
						<FitnessPageSection
							key={result.sectionId}
							sectionData={result}
							index={index}
						/>
					))}
		</Container>
	);
};

export default FitnessPage;
